import { hubAxios } from "@helpers/lib/axios";
import { HUB_ENDPOINTS } from "@memorang/constants/urls";
import { getCurrentLocale } from "@memorang/helpers/i18n";
import type { BaseItemSchema } from "@memorang/types";
import SuperJSON from "superjson";
import { PTE_FEEDBACK_AGENT_ID } from "../constants/pte/feedback";
import { extractItemContent } from "./extract-item-content";
import type { ClientGrading } from "./feedback-client-grading";

export type FeedbackResultDTO = {
	feedback: string;
};

export type FeedbackRequestParams = {
	item: BaseItemSchema;
	userResponse: string;
	clientGrading?: ClientGrading;
	userId: string;
	projectId: number;
	organizationId: number;
	sessionId?: number;
};

// Single attempt; the runner owns retries so it can seq-guard each.
export const fetchFeedbackResult = async (
	params: FeedbackRequestParams,
): Promise<FeedbackResultDTO | null> => {
	const {
		item,
		userResponse,
		clientGrading,
		userId,
		projectId,
		organizationId,
		sessionId,
	} = params;

	try {
		const { data } = await hubAxios.post<FeedbackResultDTO>(
			HUB_ENDPOINTS.FEEDBACK_AGENT,
			{
				stream: false,
				agentId: PTE_FEEDBACK_AGENT_ID,
				inputs: SuperJSON.serialize({
					item: extractItemContent(item),
					userResponse,
					outputLanguage: getCurrentLocale(),
					...(clientGrading ? { clientGrading } : {}),
				}),
				userId,
				projectId,
				organizationId,
				...(item.id != null ? { itemId: item.id } : {}),
				...(sessionId ? { sessionId } : {}),
			},
		);

		return data;
	} catch {
		return null;
	}
};
